<template>
  <v-app-bar-nav-icon 
    @click="toggleDrawer"
    :v-show="isLoggedIn"
  />
</template>

<script>
export default {
  name: "HamburgerMenuButton",
  props: [
    "toggleDrawer",
    "isLoggedIn"
  ]
}
</script>